@if (components && components.length === 0) {
  <div>
    {{ '#UTILITIES.CONTEXT.NO_COMPONENTS' | translate }}
  </div>
}
@for (component of components ?? []; track component) {
  <div class="mt-4">
    <ng-container *ngComponentOutlet="component"></ng-container>
    <hr class="soft-separator" />
  </div>
}
<div class="flex flex-row justify-end">
  <button
    class="soft-button primary"
    (click)="onSave()"
    [disabled]="loading$ | async"
    >
    @if (loading$ | async) {
      <i class="fa-regular fa-spinner fa-spin"></i>
    }
    {{ '#UTILITIES.CONTEXT.SAVE' | translate }}
  </button>
</div>
